import React, { useId } from "react";

export default function Dot({
  gradient = ["#001C80", "#001480", "#002480", "#002C80"],
  className,
  ...props
}) {
  const uid = useId();
  const id0 = `paint0_radial_${uid}`;
  const id1 = `paint1_radial_${uid}`;
  const id2 = `paint2_radial_${uid}`;
  const id3 = `paint3_linear_${uid}`;
  const id4 = `paint4_linear_${uid}`;
  const id5 = `paint5_linear_${uid}`;
  const id6 = `paint6_linear_${uid}`;
  const id7 = `paint7_linear_${uid}`;
  const id8 = `paint8_linear_${uid}`;
  const id9 = `paint9_linear_${uid}`;
  const id10 = `paint10_linear_${uid}`;
  const id11 = `paint11_linear_${uid}`;
  const id12 = `paint12_linear_${uid}`;
  const id13 = `paint13_linear_${uid}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="47"
      height="49"
      viewBox="0 0 47 49"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M36.2848 11.0021C41.5615 20.7058 38.2971 32.3325 28.951 36.9831C19.6497 41.6338 7.79948 37.5645 2.52278 27.9054C-2.75393 18.2016 0.510478 6.575 9.85651 1.92434C19.2025 -2.72631 31.008 1.34301 36.3295 11.0021H36.2848Z"
        fill={`url(#${id0})`}
      />

      <g style={{ mixBlendMode: "screen" }} opacity="0.54">
        <path
          style={{ mixBlendMode: "screen" }}
          d="M11.3319 2.10259C19.6494 -0.938227 29.7556 1.61069 35.8372 11.4486C37.7154 14.4447 38.2073 14.8919 36.1503 11.1356C30.8736 1.43182 19.1575 -2.68222 9.85617 2.01315C7.08366 3.3994 9.09596 2.90751 11.3319 2.10259Z"
          fill={`url(#${id1})`}
        />
      </g>

      <g style={{ mixBlendMode: "soft-light" }} opacity="0.61">
        <path
          d="M37.8049 21.1057C36.9106 26.293 33.7356 30.8989 28.7719 33.3584C19.9625 37.7408 8.78304 33.9397 3.81936 24.7726C0.867979 19.3617 0.733823 13.2801 2.96972 8.31641C-0.384123 13.6825 -0.741863 20.9268 2.70141 27.2321C7.84396 36.5781 19.2917 40.5133 28.28 35.9968C34.1381 33.0901 37.5366 27.3215 37.7602 21.061L37.8049 21.1057Z"
          fill={`url(#${id2})`}
        />
      </g>

      <g style={{ mixBlendMode: "overlay" }}>
        <path
          opacity="0.11"
          d="M32.764 6.80558C39.6953 14.4971 39.3823 25.7212 32.0933 31.8476C24.7596 38.0186 13.1776 36.7218 6.24634 29.0304C-0.684924 21.3389 -0.41661 10.1147 6.91712 3.94364C14.2508 -2.1827 25.8328 -0.930604 32.764 6.76087V6.80558Z"
          fill={`url(#${id3})`}
        />
        <path
          opacity="0.22"
          d="M32.6231 6.7651C39.4649 14.3224 39.1518 25.4124 31.8628 31.4941C24.6185 37.5757 13.1708 36.3683 6.32895 28.7663C-0.512884 21.1642 -0.199859 10.1189 7.08915 4.03731C14.3334 -2.04432 25.7812 -0.836939 32.6231 6.7651Z"
          fill={`url(#${id4})`}
        />
        <path
          opacity="0.33"
          d="M32.5345 6.67232C39.2869 14.1402 38.9292 25.0514 31.7296 31.0883C24.5747 37.1252 13.2611 35.9178 6.55346 28.4946C-0.19894 21.0268 0.158796 10.1156 7.35837 4.07868C14.5132 -1.91351 25.8268 -0.750845 32.5345 6.71704V6.67232Z"
          fill={`url(#${id5})`}
        />
        <path
          opacity="0.44"
          d="M32.407 6.63554C39.0252 13.9693 38.6675 24.7463 31.5573 30.6938C24.4472 36.6412 13.3125 35.5233 6.69421 28.1896C0.0759697 20.8558 0.433715 10.0788 7.54385 4.08663C14.654 -1.86085 25.7887 -0.742902 32.407 6.63554Z"
          fill={`url(#${id6})`}
        />
        <path
          opacity="0.56"
          d="M32.2579 6.53008C38.7868 13.7744 38.3843 24.4172 31.3636 30.2753C24.3429 36.178 13.3423 35.0601 6.81349 27.8605C0.284684 20.6162 0.687139 9.97336 7.70784 4.11532C14.7285 -1.78744 25.7291 -0.669494 32.2579 6.53008Z"
          fill={`url(#${id7})`}
        />
        <path
          opacity="0.67"
          d="M32.1737 6.50051C38.6131 13.6106 38.1659 24.1193 31.2347 29.9327C24.3034 35.746 13.4369 34.7175 7.04229 27.6073C0.602921 20.4972 1.0501 9.9885 7.98137 4.17518C14.9126 -1.63814 25.7344 -0.609631 32.1737 6.50051Z"
          fill={`url(#${id8})`}
        />
        <path
          opacity="0.78"
          d="M32.0427 6.44583C38.3479 13.4665 37.9008 23.7964 31.0589 29.5203C24.1724 35.2889 13.4848 34.3051 7.17961 27.2844C0.87439 20.2637 1.27685 9.93383 8.1634 4.16522C15.0052 -1.60338 25.6928 -0.574871 32.0427 6.40111V6.44583Z"
          fill={`url(#${id9})`}
        />
        <path
          opacity="0.89"
          d="M31.905 6.35234C38.1208 13.2389 37.6289 23.4346 30.8765 29.1137C24.0794 34.8376 13.526 33.8538 7.31018 26.9673C1.09439 20.0807 1.54157 9.88505 8.3834 4.20589C15.1805 -1.47328 25.6892 -0.534207 31.9497 6.35234H31.905Z"
          fill={`url(#${id10})`}
        />
        <path
          d="M31.819 6.30776C37.9454 13.0602 37.4535 23.1217 30.7011 28.7561C23.9934 34.3906 13.5742 33.4962 7.49253 26.6991C1.36619 19.9467 1.85809 9.88519 8.61048 4.25074C15.3182 -1.38371 25.6927 -0.44464 31.819 6.30776Z"
          fill={`url(#${id11})`}
        />
      </g>

      <path
        opacity="0.05"
        d="M4.64757 12.7511C3.57434 18.3408 4.9606 21.4264 5.76552 23.3045C6.481 25.0485 3.84265 23.3492 3.79793 23.3045C0.533526 18.162 2.76942 12.125 3.52963 11.6331C4.28983 11.1412 4.78172 12.125 4.64757 12.7511Z"
        fill="white"
      />
      <path
        opacity="0.1"
        d="M4.5706 12.9345C3.58681 18.2112 4.83891 21.2073 5.64383 23.0854C6.35931 24.7847 3.85511 23.2196 3.8104 23.0854C0.724863 18.1665 2.78189 12.3979 3.54209 11.8612C4.30229 11.3246 4.70475 12.3531 4.61532 12.9345H4.5706Z"
        fill="white"
      />
      <path
        opacity="0.15"
        d="M4.43575 13.1047C3.49668 18.1131 4.70406 21.0198 5.46426 22.8532C6.13503 24.5525 3.8097 23.0321 3.72027 22.8532C0.813607 18.1131 2.73648 12.7023 3.45196 12.1209C4.12273 11.5396 4.52519 12.6128 4.43575 13.1494V13.1047Z"
        fill="white"
      />
      <path
        opacity="0.2"
        d="M4.34512 13.2854C3.49548 17.9808 4.56872 20.798 5.32892 22.6315C5.99969 24.286 3.80851 22.855 3.71907 22.5867C0.991284 18.0255 2.78 12.9277 3.40605 12.3016C4.0321 11.7203 4.43456 12.7488 4.34512 13.2854Z"
        fill="white"
      />
      <path
        opacity="0.25"
        d="M4.25554 13.4606C3.45061 17.8877 4.47912 20.6155 5.19461 22.4042C5.86537 24.0588 3.80835 22.6725 3.71892 22.3595C1.17 17.9771 2.82456 13.1923 3.40589 12.5663C3.98723 11.9402 4.34497 13.0134 4.25554 13.4606Z"
        fill="white"
      />
      <path
        opacity="0.3"
        d="M4.12088 13.6413C3.36068 17.7554 4.29976 20.3937 5.01524 22.1824C5.64129 23.7923 3.76314 22.4955 3.62898 22.093C1.25894 17.9342 2.77934 13.4625 3.31596 12.7917C3.85257 12.1209 4.21032 13.2389 4.12088 13.6413Z"
        fill="white"
      />
      <path
        opacity="0.35"
        d="M4.03102 13.8262C3.36025 17.6719 4.16517 20.2208 4.88066 21.9648C5.50671 23.5747 3.76271 22.3673 3.62855 21.8754C1.39266 17.8955 2.82363 13.7367 3.31553 13.0213C3.80743 12.3058 4.12045 13.4684 4.07574 13.8262H4.03102Z"
        fill="white"
      />
      <path
        opacity="0.4"
        d="M3.94728 14.0045C3.32123 17.5819 4.08142 19.9967 4.75219 21.7407C5.37824 23.3058 3.7684 22.1879 3.58952 21.6513C1.5325 17.8502 2.82932 14.0045 3.2765 13.289C3.72368 12.5735 3.99199 13.6915 3.94728 14.0492V14.0045Z"
        fill="white"
      />
      <path
        opacity="0.44"
        d="M3.8033 14.1759C3.26668 17.4403 3.89273 19.8104 4.5635 21.5097C5.14483 23.0748 3.71386 22.0015 3.53499 21.3755C1.65684 17.7534 2.8195 14.2654 3.22196 13.4604C3.62442 12.7002 3.89273 13.8629 3.84802 14.1759H3.8033Z"
        fill="white"
      />
      <path
        opacity="0.49"
        d="M3.71983 14.3518C3.22793 17.3479 3.80926 19.5838 4.43531 21.2831C5.01665 22.8035 3.71983 21.8197 3.49624 21.149C1.79697 17.7504 2.82548 14.5307 3.18322 13.7258C3.54096 12.9209 3.76455 14.1282 3.71983 14.3966V14.3518Z"
        fill="white"
      />
      <path
        opacity="0.54"
        d="M3.57982 14.5382C3.13265 17.2212 3.57983 19.4124 4.2506 21.067C4.83193 22.5874 3.66927 21.6483 3.44568 20.9328C1.92527 17.7131 2.81963 14.8065 3.08793 13.9568C3.40096 13.1072 3.62454 14.3593 3.57982 14.5382Z"
        fill="white"
      />
      <path
        opacity="0.59"
        d="M3.4867 14.7076C3.12895 17.1223 3.48669 19.1794 4.11274 20.8339C4.64936 22.3096 3.66557 21.5047 3.44198 20.655C2.10044 17.6142 2.81593 15.0653 3.08423 14.171C3.35254 13.3213 3.53141 14.5287 3.4867 14.7076Z"
        fill="white"
      />
      <path
        opacity="0.64"
        d="M3.40749 14.8875C3.09447 17.034 3.40749 19.0016 3.98882 20.5667C4.52544 22.0424 3.6758 21.2822 3.40749 20.3878C2.20011 17.5259 2.82616 15.29 3.04975 14.3509C3.27334 13.4566 3.40749 14.7087 3.40749 14.8428V14.8875Z"
        fill="white"
      />
      <path
        opacity="0.69"
        d="M3.26622 15.0798C3.04263 16.9132 3.26622 18.7913 3.80284 20.3565C4.33945 21.7874 3.62396 21.1167 3.35566 20.1776C2.32715 17.4945 2.81904 15.5716 2.99791 14.6326C3.17679 13.6935 3.31094 14.9903 3.31094 15.0798H3.26622Z"
        fill="white"
      />
      <path
        opacity="0.74"
        d="M3.18708 15.2465C3.00821 16.8116 3.09764 18.6003 3.67897 20.1207C4.17087 21.5517 3.63426 20.9257 3.32123 19.8971C2.47159 17.4377 2.82933 15.8278 2.96349 14.844C3.09764 13.8602 3.18708 15.2018 3.18708 15.2465Z"
        fill="white"
      />
      <path
        opacity="0.79"
        d="M3.08643 15.4331C3.08643 16.7299 2.99699 18.3845 3.53361 19.9049C4.02551 21.2911 3.62304 20.7545 3.31001 19.6813C2.63925 17.4007 2.86284 16.1039 2.95227 15.0754C3.04171 14.0916 3.13115 15.4331 3.13115 15.4331H3.08643Z"
        fill="white"
      />

      <path
        style={{ mixBlendMode: "screen" }}
        d="M31.6707 7.33566C37.5287 14.6247 36.7238 24.9545 29.9266 30.4101C23.1295 35.8657 12.8444 34.39 7.0311 27.101C1.17306 19.8119 1.97799 9.48211 8.7751 4.02654C15.5722 -1.42904 25.8126 0.0466452 31.6707 7.33566Z"
        fill={`url(#${id12})`}
      />

      <g style={{ mixBlendMode: "overlay" }} opacity="0.56">
        <path
          style={{ mixBlendMode: "screen" }}
          d="M29.0025 29.641C32.8929 26.7791 35.263 22.4415 36.0679 17.7461C34.2345 17.925 32.3563 18.2827 30.4782 18.7299C22.2948 20.8316 15.5424 25.3928 11.5625 30.8037C17.0181 33.7551 23.681 33.5762 29.0025 29.641Z"
          fill={`url(#${id13})`}
        />
      </g>

      <defs>
        <radialGradient
          id={id0}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(37.7907 32.3042) rotate(-26.59) scale(49.9033 52.6155)"
        >
          <stop offset="0.32" stopColor="var(--dot-0, #001C80)" />
          <stop offset="0.33" stopColor="var(--dot-1, #001480)" />
          <stop offset="0.75" stopColor="var(--dot-2, #002480)" />
          <stop offset="1" stopColor="var(--dot-3, #002C80)" />
        </radialGradient>

        <radialGradient
          id={id1}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(22.851 -1.08559) rotate(9.69) scale(13.7284 13.7284)"
        >
          <stop offset="0.1" stopColor="#A9A9A9" />
          <stop offset="0.48" stopColor="#A9A9A9" />
          <stop offset="0.52" stopColor="#99A599" />
          <stop offset="0.69" stopColor="#589558" />
          <stop offset="0.83" stopColor="#288928" />
          <stop offset="0.94" stopColor="#0A820A" />
          <stop offset="1" stopColor="#008000" />
        </radialGradient>

        <radialGradient
          id={id2}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(34.5133 35.2905) rotate(9.69) scale(34.1197 34.1197)"
        >
          <stop offset="0.08" stopColor="#2C2C2C" />
          <stop offset="0.12" stopColor="#434343" />
          <stop offset="0.23" stopColor="#787878" />
          <stop offset="0.34" stopColor="#A2A2A2" />
          <stop offset="0.43" stopColor="#C0C0C0" />
          <stop offset="0.51" stopColor="#D2D2D2" />
          <stop offset="0.57" stopColor="#D9D9D9" />
          <stop offset="0.66" stopColor="#D6D6D6" />
          <stop offset="0.73" stopColor="#CDCDCD" />
          <stop offset="0.79" stopColor="#BDBDBD" />
          <stop offset="0.84" stopColor="#A8A8A8" />
          <stop offset="0.89" stopColor="#8C8C8C" />
          <stop offset="0.93" stopColor="#696969" />
          <stop offset="0.97" stopColor="#414141" />
          <stop offset="0.99" stopColor="#2C2C2C" />
        </radialGradient>

        <linearGradient
          id={id3}
          x1="27.9409"
          y1="38.2525"
          x2="12.7102"
          y2="-1.25005"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#003380" />
          <stop offset="0.44" stopColor="#001C80" />
          <stop offset="0.58" stopColor="#024481" />
          <stop offset="0.73" stopColor="#034989" />
          <stop offset="1" stopColor="#053694" />
        </linearGradient>

        <linearGradient
          id={id4}
          x1="28.5984"
          y1="39.8507"
          x2="13.4285"
          y2="0.54438"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#002C80" />
          <stop offset="0.44" stopColor="#002480" />
          <stop offset="0.58" stopColor="#033682" />
          <stop offset="0.73" stopColor="#062B8A" />
          <stop offset="1" stopColor="#0B4295" />
        </linearGradient>

        <linearGradient
          id={id5}
          x1="29.5962"
          y1="41.3994"
          x2="14.6198"
          y2="2.77"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#002480" />
          <stop offset="0.44" stopColor="#003380" />
          <stop offset="0.58" stopColor="#052883" />
          <stop offset="0.73" stopColor="#09358B" />
          <stop offset="1" stopColor="#103696" />
        </linearGradient>

        <linearGradient
          id={id6}
          x1="30.1966"
          y1="42.838"
          x2="15.2698"
          y2="4.48942"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#002C80" />
          <stop offset="0.44" stopColor="#001C80" />
          <stop offset="0.58" stopColor="#072A84" />
          <stop offset="0.74" stopColor="#0D298C" />
          <stop offset="1" stopColor="#152A97" />
        </linearGradient>

        <linearGradient
          id={id7}
          x1="30.6372"
          y1="44.2776"
          x2="15.8048"
          y2="6.17434"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#003380" />
          <stop offset="0.44" stopColor="#004380" />
          <stop offset="0.58" stopColor="#083A85" />
          <stop offset="0.78" stopColor="#12358F" />
          <stop offset="1" stopColor="#1B3E98" />
        </linearGradient>

        <linearGradient
          id={id8}
          x1="31.3934"
          y1="45.7191"
          x2="16.756"
          y2="8.28015"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#004380" />
          <stop offset="0.44" stopColor="#002480" />
          <stop offset="0.45" stopColor="#002C80" />
          <stop offset="0.58" stopColor="#0A2D86" />
          <stop offset="0.81" stopColor="#174892" />
          <stop offset="1" stopColor="#205F99" />
        </linearGradient>

        <linearGradient
          id={id9}
          x1="31.8375"
          y1="46.9531"
          x2="17.2532"
          y2="9.7906"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#002480" />
          <stop offset="0.44" stopColor="#002C80" />
          <stop offset="0.47" stopColor="#032681" />
          <stop offset="0.515625" stopColor="#072A83" />
          <stop offset="0.58" stopColor="#0C3D87" />
          <stop offset="0.83" stopColor="#1D3E94" />
          <stop offset="1" stopColor="#25549A" />
        </linearGradient>

        <linearGradient
          id={id10}
          x1="32.1716"
          y1="48.1958"
          x2="17.6409"
          y2="11.2683"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#002480" />
          <stop offset="0.44" stopColor="#003380" />
          <stop offset="0.49" stopColor="#053F83" />
          <stop offset="0.58" stopColor="#0D2F88" />
          <stop offset="0.85" stopColor="#224295" />
          <stop offset="1" stopColor="#2B4A9B" />
        </linearGradient>

        <linearGradient
          id={id11}
          x1="32.3798"
          y1="49.3213"
          x2="17.9851"
          y2="12.683"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#002480" />
          <stop offset="0.44" stopColor="#001C80" />
          <stop offset="0.62" stopColor="#12348A" />
          <stop offset="0.86" stopColor="#274697" />
          <stop offset="1" stopColor="#305B9C" />
        </linearGradient>

        <linearGradient
          id={id12}
          x1="14.0906"
          y1="-3.61071"
          x2="29.5815"
          y2="38.0821"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="white" />
          <stop offset="0.15" stopColor="#BCBCBC" />
          <stop offset="0.2" stopColor="#7A7A7A" />
          <stop offset="0.24" stopColor="#454545" />
          <stop offset="0.28" stopColor="#1F1F1F" />
          <stop offset="0.31" stopColor="#080808" />
          <stop offset="0.33" />
          <stop offset="0.48" stopColor="#020202" />
          <stop offset="0.57" stopColor="#0A0A0A" />
          <stop offset="0.64" stopColor="#181818" />
          <stop offset="0.71" stopColor="#2D2D2D" />
          <stop offset="0.76" stopColor="#474747" />
          <stop offset="0.82" stopColor="#676767" />
          <stop offset="0.87" stopColor="#8D8D8D" />
          <stop offset="0.92" stopColor="#B9B9B9" />
          <stop offset="0.96" stopColor="#EAEAEA" />
          <stop offset="0.98" stopColor="white" />
        </linearGradient>

        <linearGradient
          id={id13}
          x1="37.1171"
          y1="43.8804"
          x2="23.581"
          y2="20.2805"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A9A9A9" />
          <stop offset="0.06" stopColor="#8E8E8E" />
          <stop offset="0.19" stopColor="#5C5C5C" />
          <stop offset="0.31" stopColor="#343434" />
          <stop offset="0.42" stopColor="#171717" />
          <stop offset="0.51" stopColor="#060606" />
          <stop offset="0.58" />
          <stop offset="0.69" stopColor="#020202" />
          <stop offset="0.76" stopColor="#0A0A0A" />
          <stop offset="0.81" stopColor="#181818" />
          <stop offset="0.86" stopColor="#2D2D2D" />
          <stop offset="0.9" stopColor="#474747" />
          <stop offset="0.94" stopColor="#676767" />
          <stop offset="0.98" stopColor="#8C8C8C" />
          <stop offset="1" stopColor="#A9A9A9" />
        </linearGradient>
      </defs>
    </svg>
  );
}
